import React, { Fragment } from 'react';

import { BreadcrumbsV2 } from '@zola/zola-ui/src/components/BreadcrumbsV2';
import { PageWrapper } from 'components/LP/v3/PageWrapper.styles';
import ExpertAdviceFooter from 'components/expert-advice/ExpertAdviceFooter';
import FeaturedArticle from 'components/expert-advice/FeaturedArticle';
import FeaturedArticlesCarousel from 'components/expert-advice/FeaturedArticlesCarousel';
import SummaryHeader from 'components/expert-advice/SummaryHeader';

import { ExpertAdviceFooterType, TopicType } from 'libs/contentful/types';
import { UserContext } from '@zola-helpers/client/dist/es/@types';

import { EA_PATH, EA_PATH_TOPIC } from 'constants/expertAdvice';

import { BreadcrumbsContainer } from 'styles/expertAdviceShared.styles';
import Footer from 'components/ui/Footer/Footer';

type TopicPageProps = {
  expertAdviceFooter: ExpertAdviceFooterType;
  isPostAuthNav3: boolean;
  renderMarketingModuleSection: (i: 1 | 2 | 3 | 4 | 5) => JSX.Element;
  topic: TopicType;
  userCtx: UserContext;
};

const TopicPage = ({
  expertAdviceFooter,
  isPostAuthNav3,
  renderMarketingModuleSection,
  topic,
  userCtx,
}: TopicPageProps): JSX.Element => {
  const { featured = [], slug = '', subtopics = [] } = topic;
  const topicHref = `${EA_PATH_TOPIC}/${slug}`;
  const breadcrumbs = [{ to: EA_PATH, label: 'Expert advice' }];

  const renderMarketingModule = (subtopicIndex: number): JSX.Element => {
    switch (subtopicIndex) {
      case 2:
        return renderMarketingModuleSection(1);
      case 5:
        return renderMarketingModuleSection(2);
      case 8:
        return renderMarketingModuleSection(3);
      case 11:
        return renderMarketingModuleSection(4);
      case 14:
        return renderMarketingModuleSection(5);
      default:
    }
    return <></>;
  };

  return (
    <PageWrapper isPostAuthNav3={isPostAuthNav3}>
      <SummaryHeader breadcrumbs={breadcrumbs} topic={topic} topicHref={topicHref} />
      <FeaturedArticle featuredArticle={featured[0]} />
      {subtopics.map((subtopic, i) =>
        subtopic.featuredArticles && subtopic.featuredArticles.length > 0 ? (
          <Fragment key={i}>
            <FeaturedArticlesCarousel
              articles={subtopic.featuredArticles}
              title={subtopic.name}
              viewAllHref={`${topicHref}/${subtopic.slug}`}
            />
            {renderMarketingModule(i)}
          </Fragment>
        ) : (
          <></>
        )
      )}
      <BreadcrumbsContainer borderBottom onlyMobile>
        <BreadcrumbsV2 currentSelectionLabel={topic.name} disableBackLink linkItems={breadcrumbs} />
      </BreadcrumbsContainer>
      <ExpertAdviceFooter expertAdviceFooter={expertAdviceFooter} noBorder />
      <Footer userCtx={userCtx} />
    </PageWrapper>
  );
};

export default TopicPage;
